import type { HealthData } from "@/types/public-data"

interface HealthCardProps {
  data: HealthData
}

export default function HealthCard({ data }: HealthCardProps) {
  return (
    <div className="rounded-xl border border-stone bg-white p-6">
      <h3 className="font-display text-lg font-semibold text-charcoal">
        Health
      </h3>

      <div className="mt-4 flex gap-8">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.15em] text-slate">
            Male life expectancy
          </p>
          <p className="mt-1 text-2xl font-bold text-charcoal">
            {data.lifeExpectancyMale !== null
              ? `${data.lifeExpectancyMale} yrs`
              : "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.15em] text-slate">
            Female life expectancy
          </p>
          <p className="mt-1 text-2xl font-bold text-charcoal">
            {data.lifeExpectancyFemale !== null
              ? `${data.lifeExpectancyFemale} yrs`
              : "N/A"}
          </p>
        </div>
      </div>

      <p className="mt-4 text-xs text-slate">
        Source: PHE Fingertips, {data.areaName}
      </p>
    </div>
  )
}
